import { render } from "./connectedCompanyPageDialog.vue?vue&type=template&id=0ea3ea6e"
import script from "./connectedCompanyPageDialog.vue?vue&type=script&lang=js"
export * from "./connectedCompanyPageDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__